import React, { useCallback, useEffect } from 'react'
import {
  Typography,
  // ToggleButton,
  // ToggleButtonGroup,
  Grid,
  Box,
  useTheme,
  IconButton,
} from '@mui/material'

import {
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  // LineChart,
  // Line,
  AreaChart,
  Area,
} from 'recharts'
import useCustomStyles from '../../../../../utils/hooks/CustomStylesHook'
import {
  API_VERSION_V3,
  DATE_DIRECTIONS,
  GRAPH_PERIODS,
  VITAL_KEYS,
} from '../Constant'
import dayjs from 'dayjs'
import { ChevronLeft, ChevronRight } from '@mui/icons-material'
import { getSleepTracking } from '../../../../../services/DeviceServices'
import { useAppSelector } from '../../../../../app/hooks'
import { selectPatientData } from '../../../OpdPatientSlice'

const styles = (theme: any) => ({
  header: {
    textAlign: 'center',
    marginBottom: theme.spacing(3),
  },
  toggleGroup: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: theme.spacing(2),
  },

  toggleBtn: {
    fontSize: '14px',
    fontWeight: 600,
    minWidth: '60px',
  },
  dateDisplay: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '10px',
  },
})

const SkinTemperatureTracking: React.FC = () => {
  const theme = useTheme()
  const classes = useCustomStyles(styles, theme)
  const [period] = React.useState(GRAPH_PERIODS.DAY)
  const [currentDate, setCurrentDate] = React.useState(dayjs())
  const [chartData, setChartData] = React.useState([])
  const [avgData, setAvgData] = React.useState<any>({})
  const patient = useAppSelector(selectPatientData)

  // const handlePeriodChange = (
  //   event: React.MouseEvent<HTMLElement>,
  //   newPeriod: string | null
  // ) => {
  //   if (newPeriod !== null) {
  //     setPeriod(newPeriod)
  //   }
  // }

  const changeDate = (direction: string) => {
    const amount =
      period === GRAPH_PERIODS?.DAY
        ? 1
        : period === GRAPH_PERIODS?.WEEK
        ? 7
        : 30
    setCurrentDate((prev) =>
      prev.add(direction === DATE_DIRECTIONS?.NEXT ? amount : -amount, 'day')
    )
  }

  const handleGetSkinTemperature = useCallback(async () => {
    const response = await getSleepTracking(
      patient?.muhId,
      currentDate.format('YYYY-MM-DD'),
      VITAL_KEYS?.SKIN_TEMP,
      API_VERSION_V3
    )
    if (response?.success) {
      setChartData(response?.data?.temperatureReadings)
      setAvgData({
        average: response?.data?.average?.toFixed(0),
        minimum: response?.data?.min?.toFixed(0),
        maximum: response?.data?.max?.toFixed(0),
      })
    }
  }, [patient?.muhId, currentDate])

  useEffect(() => {
    handleGetSkinTemperature()
  }, [handleGetSkinTemperature])

  return (
    <Box m={3}>
      <Box className={classes?.toggleGroup}>
        {/* <ToggleButtonGroup
          value={period}
          exclusive
          onChange={handlePeriodChange}
          color='primary'
          size='small'
        >
          <ToggleButton value='day' className={classes?.toggleBtn}>
            D
          </ToggleButton>
          <ToggleButton value='week' className={classes?.toggleBtn}>
            W
          </ToggleButton>
          <ToggleButton value='month' className={classes?.toggleBtn}>
            M
          </ToggleButton>
        </ToggleButtonGroup> */}
        <Box className={classes?.dateDisplay}>
          <IconButton
            onClick={() => changeDate(DATE_DIRECTIONS?.PREVIOUS)}
            color='inherit'
            aria-label='previous-date'
          >
            <ChevronLeft />
          </IconButton>
          <Typography>
            {currentDate.format(
              period === GRAPH_PERIODS?.DAY
                ? 'MMM DD, YYYY'
                : period === GRAPH_PERIODS?.WEEK
                ? '[Week of] MMM DD, YYYY'
                : 'MMM YYYY'
            )}
          </Typography>
          <IconButton
            onClick={() => changeDate(DATE_DIRECTIONS?.NEXT)}
            color='inherit'
            aria-label='next-date'
            disabled={
              currentDate.isSame(dayjs(), 'day') ||
              currentDate.isAfter(dayjs(), 'day')
            }
          >
            <ChevronRight />
          </IconButton>
        </Box>
      </Box>

      <Grid container direction={'column'}>
        <Typography fontSize={'16px'} ml={4} mb={0.5}>
          Temperature
        </Typography>
        <ResponsiveContainer width='100%' height={170}>
          <AreaChart data={chartData}>
            <XAxis dataKey='time' fontSize={'12px'} />
            <YAxis domain={['dataMin', 'dataMax']} fontSize='12px' />
            <Tooltip />
            <Area
              dataKey='value'
              strokeWidth={1.5}
              dot={true}
              stroke='#8884d8'
              fill='#8884d8'
            />
          </AreaChart>
        </ResponsiveContainer>
        <Box
          display={'flex'}
          justifyContent={'center'}
          alignItems={'center'}
          gap={3}
          mt={1.5}
          ml={4}
        >
          <Grid
            item
            xs={6}
            textAlign={'center'}
            border={'1px solid grey'}
            borderRadius={'20px'}
            p={2}
          >
            <Typography variant='h6'>{avgData?.average}</Typography>
            <Typography variant='subtitle2'>Avg</Typography>
          </Grid>
          <Grid
            item
            xs={6}
            textAlign={'center'}
            border={'1px solid grey'}
            borderRadius={'20px'}
            p={2}
          >
            <Typography variant='h6'>{avgData?.minimum}</Typography>
            <Typography variant='subtitle2'>Minimum</Typography>
          </Grid>
          <Grid
            item
            xs={6}
            textAlign={'center'}
            border={'1px solid grey'}
            borderRadius={'20px'}
            p={2}
          >
            <Typography variant='h6'>{avgData?.maximum}</Typography>
            <Typography variant='subtitle2'>Maximum</Typography>
          </Grid>
        </Box>
      </Grid>
    </Box>
  )
}

export default SkinTemperatureTracking
